import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./SpecialitySection.css";

const SpecialitySection = () => {
  const specialities = [
    {
      title: "Unlimited Music Distribution",
      desc: "No limit, Distribute unlimited tracks worldwide over 150 stores.",
      icon: <img src="/Images/service/unlimited-distribution.png" alt="Unlimited Music Distribution" style={{ width: "40px", height: "40px", objectFit: "contain" }} />,
      color: "linear-gradient(-45deg, #00ef86, #008cff, #ec3258, #fcda00)",
    },
    {
      title: "Global Payments",
      desc: "Get your royalties every month from anywhere in the world.",
      icon: <img src="/Images/service/global-payments.png" alt="Global Payments" style={{ width: "40px", height: "40px", objectFit: "contain" }} />,
      color: "linear-gradient(-45deg, #00ef86, #008cff, #ec3258, #fcda00)",
    },
    {
      title: "Detailed Reporting",
      desc: "Detailed reporting of your earning, check the details of your sales on dashboard.",
      icon: <img src="/Images/service/reporting.png" alt="Detailed Reporting" style={{ width: "40px", height: "40px", objectFit: "contain" }} />,
      color: "linear-gradient(-45deg, #00ef86, #008cff, #ec3258, #fcda00)",
    },
    {
      title: "Quick Support",
      desc: "Our support professionals answer your questions with in 2hours, we are open to help you 7 days a week.",
      icon: <img src="/Images/service/quick-support.png" alt="Quick Support" style={{ width: "40px", height: "40px", objectFit: "contain" }} />,
      color: "linear-gradient(-45deg, #00ef86, #008cff, #ec3258, #fcda00)",
    },
  ];

  return (
    <section className="speciality-section-premium">
      <Container>
        <Row className="g-4">
          {specialities.map((item, index) => (
            <Col key={index} lg={3} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="speciality-card-premium"
              >
                <div
                  className="card-icon-box"
                  style={{ "--icon-color": item.color }}
                >
                  {item.icon}
                </div>
                <div className="card-content">
                  <h4 className="card-title">{item.title}</h4>
                  <p className="card-desc">{item.desc}</p>
                </div>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default SpecialitySection;
